export function getHostName() {
  try {
    return window.location.hostname;
  } catch (e) {
    return null;
  }
  return null;
}
